import React from "react";
import { useEffect, useState } from "react";
import Storage from "@/app/core/util/Storage";
import InvoiceModal from "@/app/core/layouts/main-components/charge/InvoiceModal";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { AddressBookController } from "@/app/core/base/controllers/AddressBookController";
import { TypeTranslate } from "@/app/core/util/helpers/UserHelper";
import { toast } from "react-toastify";
import AddressModal from "./AddressModal";

export default function AddressBookcomponent() {
    const userData = Storage.getUserData();
    const [selected, setSelected] = useState({});
    const [address, setaddress] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        loadBook()
    }, []);

    async function loadBook() {
        await AddressBookController.Get(res => {
            for (let s in res) {
                res[s].address = `${res[s].number}, ${res[s].street}, ${res[s].neighborhood} | ${res[s].city} - ${res[s].state}`;
            }
            setaddress(res);
        })
    }

    function open(item) {
        setSelected(item);
        setShowModal(true)
    }

    function deleteType(item) {
        if (window.confirm(Translate(Message.DeleteConfirm))) {
            AddressBookController.Delete(item.id, res => {
                toast.success(Translate(Message.DeleteSuccess));
                loadBook()
            })
        }
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-6">
                <h2 className="content-heading font-w700">{Translate(Message.AddressBook)}</h2>
            </div>
            <div className="col-md-6 text-right">
                <button className="btn btn-success" onClick={() => setShowModal(true)}>{Translate(Message.Add)}</button>
            </div>
            <div className="col-md-12">
                <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th>{Translate(Message.Name)}</th>
                            <th>{Translate(Message.Responsible)}</th>
                            <th>Email</th>
                            <th>{Translate(Message.Address)}</th>
                            <th>{Translate(Message.Type)}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {address && address.map(item => (
                            <tr>
                                <th>{item.name}</th>
                                <th>{item.responsibleName}</th>
                                <th>{item.email}</th>
                                <th>
                                    {`${item.number}, ${item.street}, ${item.neighborhood} | ${item.city} - ${item.state}`}
                                </th>
                                <th>{TypeTranslate(item.personType)}</th>
                                <th>
                                    <button className="btn btn-dual btn-sm" onClick={() => open(item)}>
                                        <i className="far fa-eye" /> {Translate(Message.Open)}
                                    </button>
                                    <button className="btn btn-dual btn-sm" onClick={() => deleteType(item)}>
                                        <i className="si si-close text-danger" /> {Translate(Message.Delete)}
                                    </button>
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {address && address.length == 0 ?
                    <div>
                        <div className="col-12 text-center">
                            <h4 className="font-w700 text-dark">{Translate(Message.DontHaveAddress)}</h4>
                            <p className="font-w700 text-dark"></p>
                            <hr style={{ width: 60 }} />
                        </div>
                    </div>
                    : ""}
            </div>
            <AddressModal
                show={showModal}
                selected={selected}
                onHide={() => setShowModal(false) | loadBook() | setSelected({})}
            />
        </div>
    )
}